import React, { useEffect } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import loadScript from 'lib/window/loadScript'
import switchFunc from 'lib/function/switchFunc'
import FacebookRoundIcon from 'LuxKit/Icons/custom/FacebookRoundIcon'
import SolidFacebookMessengerIcon from 'LuxKit/Icons/solid/SolidFacebookMessengerIcon'
import LineWhatsappIcon from 'LuxKit/Icons/line/LineWhatsappIcon'
import SolidTwitterIcon from 'LuxKit/Icons/solid/SolidTwitterIcon'
import PinterestIcon from 'LuxKit/Icons/custom/PinterestIcon'
import TextButton from 'LuxKit/Button/TextButton'
import { mediaHoverable } from 'lib/theme/mediaQueries'

const getIconFromKey = switchFunc({
  facebook: <FacebookRoundIcon size="XS" />,
  messenger: <SolidFacebookMessengerIcon size="XS" />,
  whatsapp: <LineWhatsappIcon size="XS" />,
  twitter: <SolidTwitterIcon size="XS" />,
  pinterest: <PinterestIcon size="XS" />,
})

export const SOCIAL_SHARE_NETWORKS = [
  {
    key: 'facebook',
    name: 'Facebook',
    icon: getIconFromKey('facebook'),
  },
  {
    key: 'messenger',
    name: 'Facebook Messenger',
    icon: getIconFromKey('messenger'),
  },
  {
    key: 'whatsapp',
    name: 'WhatsApp',
    icon: getIconFromKey('whatsapp'),
  },
  {
    key: 'twitter',
    name: 'Twitter',
    icon: getIconFromKey('twitter'),
  },
  {
    key: 'pinterest',
    name: 'Pinterest',
    icon: getIconFromKey('pinterest'),
  },
]

export const SOCIAL_SHARE_NETWORKS_VARIANT = [
  {
    key: 'whatsapp',
    name: 'WhatsApp',
    icon: getIconFromKey('whatsapp'),
  },
  {
    key: 'facebook',
    name: 'Facebook',
    icon: getIconFromKey('facebook'),
  },
  {
    key: 'messenger',
    name: 'Facebook Messenger',
    icon: getIconFromKey('messenger'),
  },
]

export const ShareOption = styled(TextButton)`
  display: flex;
  justify-content: flex-start;
  padding: ${rem(16)} 0;
  width: 100%;

  .st-custom-button-name {
    ${mediaHoverable} {
      &:hover {
        text-decoration: underline;
      }
    }
  }
`

interface Props {
  shareConfig: any;
  onShare: (networkName: string, networkKey?: string) => void;
}

function ShareButtons(props: Props) {
  const {
    shareConfig,
    onShare,
  } = props

  useEffect(() => {
    loadScript('https://platform-api.sharethis.com/js/sharethis.js#product=custom-share-buttons', { async: true }).then(() => {
      if (window.__sharethis__) {
        const shareThisConfig = {
          id: 'sharethis-' + Date.now(),
          alignment: 'center',
          color: 'social',
          enabled: true,
          font_size: 16,
          labels: 'cta',
          language: 'en',
          networks: SOCIAL_SHARE_NETWORKS.map((network) => network.key),
          padding: 12,
          radius: 4,
          show_total: false,
          size: 40,
        }
        window.__sharethis__.load('custom-share-buttons', shareThisConfig)
      }
    })
  }, [])

  return <>
    {SOCIAL_SHARE_NETWORKS_VARIANT.map((network) => (
      <ShareOption
        kind="tertiary"
        onClick={() => onShare(network.name, network.key)}
        key={network.key}
        className="st-custom-button"
        data-network={network.key}
        data-url={shareConfig.url}
        data-image={shareConfig.shareImg}
        data-title={shareConfig.shareTitle}
        data-description={shareConfig.shareMessage}
        startIcon={getIconFromKey(network.key)}
      >
        {network.name}
      </ShareOption>
    ))}
  </>
}

export default ShareButtons
